/**
 * JavaScript to be fired on all pages
 *
 * Loading order of scripts
 * 1. scripts in init() in the common file
 * 2. scripts in init() in page specific files, e.g. home
 * 3. scripts in finalize() in the common file
 */

export default {
    init() {
        // scripts here run on the DOM load event
        require('./other/nav');
        require('./other/mega-menu');
        require('./sections/page-header');
        require('./components/submenu');
        require('./other/animations');
        require('./other/dark-mode');
        require('./partials/footer-full');
    },
    finalize() {
        // scripts here fire after init() runs and after page specific JS runs
        require('./other/generic');
        require('./other/facetwp');
        require('./other/bootstrap-custom');
        require('./components/facetwp-filter-main');
        require('./components/list-expandable');
        require('./components/form');
        require('./components/media');
        require('./sections/timeline');
        require('./sections/slider-reviews');
        require('./sections/card-grid');
        require('./sections/tabs');
        require('./sections/content');
        require('./sections/team');
        require('./sections/resources');
        require('./sections/slider-swiper');
        require('./sections/featured-related');
        require('./sections/featured-quotes');
        require('./sections/quotes-with-background');
        require('./sections/submenu');
        require('./sections/logo-slider');
        require('./other/user-registration');
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js